import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { HeatingCircuit } from 'z3k-config';
import { MaterialAutocomplete, MaterialBoolControl, NullableNumberInput, } from 'console/shared/components/fields';
import { unpack_validation } from 'webui/Z3KConfigParser/validation/types';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { Box, Divider } from '@mui/material';
import { noop } from 'ts-essentials';
import { preventDefault } from 'shared/hooks/utils';
import { Control } from 'console/shared/components/fields/control';
import { PZAPlot } from 'console/device-settings/z3k/components/utils/pza-pane/plot';
import { createPredefinedCurve, predefinedCurveNumbers, } from 'console/device-settings/z3k/components/utils/pza-pane/utils';
function is_pza_available(control_mode) {
    return control_mode == HeatingCircuit.ControlMode.PZA;
}
export const WeatherCard = memo(function WeatherCard(props) {
    const { state, validation, onChangeTabState, service_mode } = props;
    const [xy, setXY] = useState([]);
    useEffect(() => {
        if (state.pza != null) {
            setXY(createPredefinedCurve(state.pza));
        }
    }, []);
    const onSetPredefinedCurve = useCallback((new_id) => {
        onChangeTabState({ pza: new_id });
        if (new_id != null) {
            setXY(createPredefinedCurve(new_id));
        }
        else {
            setXY([]);
        }
    }, [setXY, createPredefinedCurve, onChangeTabState]);
    const onChangePZA = useCallback((value) => {
        onChangeTabState({ pza: value });
        if (value != null) {
            setXY(createPredefinedCurve(value));
        }
        else {
            setXY([]);
        }
    }, [onChangeTabState, createPredefinedCurve]);
    const predefined_options = useMemo(() => [
        {
            name: 'Стандартные кривые',
            options: predefinedCurveNumbers.map((curveNo) => ({
                name: `Кривая ${curveNo.toFixed(1)}`,
                id: curveNo,
            })),
        },
    ], [predefinedCurveNumbers]);
    if (HeatingCircuit.isDHW(state.circuit)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [(state.control_mode == null || is_pza_available(state.control_mode)) && (_jsxs(SettingCard, { title: "\u0412\u044B\u0431\u043E\u0440 \u043A\u0440\u0438\u0432\u043E\u0439 \u041F\u0417\u0410", children: [_jsx(Control, { label: "\u041A\u0440\u0438\u0432\u0430\u044F \u041F\u0417\u0410", validation_result: unpack_validation(validation, 'pza'), validation_warnings_result: null, value: state.pza, onChange: onChangePZA, field: (input_props) => (_jsx(NullableNumberInput, { min: 0.1, max: 4.0, step: 0.1, ...input_props })) }), service_mode && (_jsx(SettingFullRow, { children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, width: "100%", children: [_jsx(Divider, { flexItem: true }), _jsx("form", { autoComplete: "off", onSubmit: preventDefault, children: _jsx(MaterialAutocomplete, { label: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0435 \u043A\u0440\u0438\u0432\u044B\u0435 \u041F\u0417\u0410", value: state.pza &&
                                            predefinedCurveNumbers.includes(state.pza)
                                            ? state.pza
                                            : null, onChange: onSetPredefinedCurve, options: predefined_options, validation_result: unpack_validation(validation, 'pza'), validation_warnings_result: null }) }), _jsx(Box, { flexGrow: 1, children: _jsx(PZAPlot, { temps: xy, onChange: noop }) })] }) }))] })), _jsxs(SettingCard, { title: "\u041B\u0435\u0442\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C", children: [_jsx(MaterialBoolControl, { label: "\u041F\u0435\u0440\u0435\u0445\u043E\u0434\u0438\u0442\u044C \u0432 \u043B\u0435\u0442\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C", value: state.winter_summer_switch, onChange: (checked) => onChangeTabState({
                            winter_summer_switch: checked,
                            summer_threshold: state.summer_threshold ?? 20,
                        }) }), _jsx(Control, { label: "\u041F\u043E\u0440\u043E\u0433 \u0443\u043B\u0438\u0447\u043D\u043E\u0439 t\u00B0", validation_result: unpack_validation(validation, 'summer_threshold'), validation_warnings_result: null, value: state.summer_threshold, onChange: (value) => onChangeTabState({ summer_threshold: value }), field: (input_props) => (_jsx(NullableNumberInput, { min: 5, max: 35, disabled: !state.winter_summer_switch, ...input_props })) })] })] }));
});
